module.exports = __webpack_public_path__ + "static/media/view3.b7048eb0.jpg";